import { useMemo } from "react";
import { buildDirectionProperty } from "./buildDirectionProperty";
var createDirection = function(direction) {
    var upper = makeFirstCharUpperCase(direction);
    return {
        direction: direction,
        upper: upper,
        padding: "padding".concat(upper),
        margin: "margin".concat(upper),
        borderWidth: "border".concat(upper, "Width"),
        borderStyle: "border".concat(upper, "Style"),
        borderColor: "border".concat(upper, "Color"),
        borderTopRadius: "borderTop".concat(upper, "Radius"),
        borderBottomRadius: "borderBottom".concat(upper, "Radius")
    };
};
var left = createDirection('left');
var right = createDirection('right');
export function makeReadingDirections() {
    var isRtl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        start: isRtl ? right : left,
        end: isRtl ? left : right,
        readingDirection: buildDirectionProperty(isRtl)
    };
}
export function useReadingDirections(isRtl) {
    return useMemo(function() {
        return makeReadingDirections(isRtl);
    }, [
        isRtl
    ]);
}
function makeFirstCharUpperCase(baseString) {
    var baseArray = baseString.split('');
    baseArray[0] = baseArray[0].toUpperCase();
    return baseArray.join('');
}
export default useReadingDirections;
